import React from 'react';
import styles from './CustomerBenefits.module.css';
import { Row, Col, Container } from 'reactstrap';
import { ReactComponent as CheckmarkIcon } from '../../assets/images/Vendor/ICP/benefits-checkmark.svg';

const CustomerBenefitsMCC = () => {

    const serviceBenefits = () => {
        const serviceInfo = [
            'Variety of competitive labor reimbursement rate options',
            'Comprehensive coverage options – Labor Only or Parts and Labor',
            'Service contract terms up to 10 years',
            'Available on ANY major HVAC brands',
            'Easy sales and claims submissions through our online portal'
        ]
        return (
            serviceInfo.map((benefit, index) => {
                return <div key={index}>
                    <div><CheckmarkIcon /></div>
                    <div>{benefit}</div>
                </div>
            })
        );
    };

    return (
        <Container fluid>
            <Row className={styles.customerBenefitsContainer}>
                <Col sm='12' md='12' lg='6' className='p-0'>
                    <div className={styles.benefitsLoginMCC}></div>
                </Col>
                <Col sm='12' md='12' lg='6' className='p-0'>
                    <div className={styles.benefitsContainer}>
                        <h1>A ToolBox Full of Options — <br/> You Choose How to Use Them</h1>
                        <div className={styles.serviceBenefits}>
                            {serviceBenefits()}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomerBenefitsMCC;